<script>import { getField } from "./forms.js";
import { createEventDispatcher } from "svelte";
import { Locale, dictionaries } from "../../i18n/index.js";
import { getTexts } from "../../schemas/index.js";
export let name;
export let story;
export let value;
export let errors;
export let disabled = false;
export let formSchema = void 0;
export let control;
export let locale;
export let context;
const dispatch = createEventDispatcher();
$: {
  value[name] = value[name] !== void 0 ? value[name] : control.schema.schema.default;
}
const onChange = (ev) => {
  value[name] = ev.detail.value;
  value = value;
  dispatch("changed", ev.detail);
};
const texts = getTexts(
  control.schema,
  locale,
  dictionaries[locale] ?? dictionaries.en,
  formSchema,
  name
);
const type = control.input ? getField(control.input?.type) : void 0;
</script>

{#if type}
	<svelte:component
		this={type}
		on:changed={onChange}
		on:state
		{name}
		label={texts.title}
		callToInput={texts.cti}
		assistText={texts.description}
		{story}
		value={value[name]}
		error={errors[name]}
		{disabled}
		{control}
		{locale}
		{context}
	/>
{/if}
